import {
  Box,
  Button,
  Grid,
  Typography,
  Modal,
  TextField,
  MenuItem,
} from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import { useEffect, useState } from "react";
import {
  CreateAccountDetailsService,
  getAccountDetailsService,
  getAccountReportService,
} from "../../services/accountService";
import useStore from "../../useStore";
import AccountBalance from "../../components/accounts/accountBalance";
import AccountTable from "../../components/accounts/accountTable";
import { getAllAgentsService } from "../../services/agentService";
import { toast } from "react-toastify";
import { imageUploadService } from "../../services/imageUploadService";
import * as XLSX from "xlsx";

const downloadExcel = (data) => {
  // Transform data into a worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Accounts History");

  // Generate a buffer and trigger download
  XLSX.writeFile(workbook, "AccountsHistory.xlsx");
};

function Accounts() {
  const { setBalance, setAccountHistory } = useStore();
  const [imageUrl, setImageUrl] = useState("");
  const [open, setOpen] = useState(false); // Modal state
  const [agents, setAgents] = useState([]); // Agents for dropdown
  const [selectedAgent, setSelectedAgent] = useState(""); // Selected agent
  const [salary, setSalary] = useState(""); // Salary amount
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openExpenditureModal, setOpenExpenditureModal] = useState(false); // Expenditure modal state
  const [expenditureDetails, setExpenditureDetails] = useState({
    what: "",
    amount: "",
    image: null,
  });
  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleGenerateClick = async () => {
    const report = await getAccountReportService();
    if (report) {
      downloadExcel(report?.report);
    }
  };
  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService();
      setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
    } catch (err) {
      toast.error(err.message);
    }
  };

  const fetchData = async () => {
    const data = await getAccountDetailsService();
    console.log(data);
    setBalance(data?.balance);
    setAccountHistory(data?.history);
  };

  useEffect(() => {
    fetchData();
    fetchAgents();
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    console.log("Submitting salary credit:", { selectedAgent, salary });
    // API call to submit salary credit
    const response = await CreateAccountDetailsService(
      "Salary Credit",
      selectedAgent,
      salary,
      false
    );
    if (response.success) {
      setSelectedAgent("");

      handleClose();
      toast.success("Added to account success");
    } else {
      toast.error("something went wrong!! please try again");
    }
  };
  const handleExpenditureSubmit = async () => {
    console.log("Submitting expenditure:", expenditureDetails);
    // API call to submit expenditure details
    setOpenExpenditureModal(false);
    const response = await CreateAccountDetailsService(
      expenditureDetails?.what,
      "-",
      expenditureDetails?.amount,
      false,
      imageUrl
    );
    if (response.success) {
      handleClose();
      toast.success("Added to account success");
    } else {
      toast.error("something went wrong!! please try again");
    }
  };

  const handleExpenditureChange = (field, value) => {
    setExpenditureDetails((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
          <Box height={65} />
          <Box>
            <Typography variant="h4">Accounts</Typography>
          </Box>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Box mt={1}>
                {/* Replace with your AccountBalance component */}
                <AccountBalance />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
                <Button variant="contained" onClick={handleOpen}>
                  Add Salary Credit
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setOpenExpenditureModal(true)}
                >
                  Add Expenditure
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  m: 1,
                }}
              >
                <TextField
                  type="date"
                  size="small"
                  value={startDate}
                  onChange={handleStartDateChange}
                  sx={{ background: "#fff", borderRadius: "8px" }}
                />
                <TextField
                  type="date"
                  size="small"
                  value={endDate}
                  onChange={handleEndDateChange}
                  sx={{ background: "#fff", borderRadius: "8px" }}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleGenerateClick}
                  sx={{
                    py: 0.5,
                    bgcolor: "green",
                    textTransform: "capitalize",
                    fontSize: "16px",
                    borderRadius: "8px",
                  }}
                >
                  Download
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box>
            <AccountTable />
          </Box>
        </Box>
      </Box>

      {/* Add Salary Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add Salary Credit
          </Typography>

          <Typography mt={2}>Salary Amount</Typography>
          <TextField
            select
            fullWidth
            sx={{ m: 0 }}
            size="small"
            value={selectedAgent}
            onChange={(e) => setSelectedAgent(e.target.value)}
            margin="normal"
          >
            {agents?.map((agent) => (
              <MenuItem key={agent?.code} value={agent?.code}>
                {agent?.userName}
              </MenuItem>
            ))}
          </TextField>
          <Typography mt={2}>Salary Amount</Typography>
          <TextField
            fullWidth
            sx={{ m: 0 }}
            size="small"
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
            type="number"
            margin="normal"
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openExpenditureModal}
        onClose={() => setOpenExpenditureModal(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add Expenditure
          </Typography>

          <Typography mt={2}>Expenditure</Typography>
          <TextField
            fullWidth
            size="small"
            sx={{ m: 0 }}
            value={expenditureDetails.what}
            onChange={(e) => handleExpenditureChange("what", e.target.value)}
            margin="normal"
          />

          <Typography mt={2}>Amount</Typography>
          <TextField
            fullWidth
            size="small"
            sx={{ m: 0 }}
            value={expenditureDetails.amount}
            onChange={(e) => handleExpenditureChange("amount", e.target.value)}
            type="number"
            margin="normal"
          />

          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Bill
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  try {
                    const formData = new FormData();
                    formData.append("image", file);

                    // Show a preview of the image during upload

                    handleExpenditureChange("image", file);

                    //Upload the image and update the state with the returned URL
                    const uploadedUrl = await imageUploadService(formData);
                    setImageUrl(uploadedUrl);

                    toast.success("Image uploaded successfully!");
                  } catch (err) {
                    handleExpenditureChange("image", null);
                    toast.error(err);
                  }
                }
              }}
            />
          </Button>

          {expenditureDetails?.image && (
            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Typography variant="body2">Preview:</Typography>
              <img
                src={URL?.createObjectURL(expenditureDetails?.image)}
                alt="Uploaded Bill"
                style={{
                  maxWidth: "100px",
                  maxHeight: "150px",
                  borderRadius: "8px",
                }}
              />
            </Box>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button variant="contained" onClick={handleExpenditureSubmit}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default Accounts;
